module.exports = __webpack_public_path__ + "static/media/ai-power-search.064bc8fc.png";